import achievementsData from "./achievements.json";

export default achievementsData.achievements;
